import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import AllServiceList from "./sections/AllServiceList";
import AllServiceFaq from "./sections/AllServiceFaq";
import AllServiceDisease from "./sections/AllServiceDisease";
import PRKIMG from "../../assets/images/all-service-disease-1.jpg";
import VCSIMG from "../../assets/images/all-service-disease-2.jpg";
import AppoinmentSection from "../../components/appointment-section/AppoinmentSection";
import MainReview from "../main/sections/MainReview";
import AboutClinicForm from "../aboutClinic/sections/AboutClinicForm";
import Location from "../../sections/Location";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerServiceAll",
  },
];

const PRKLIST = [
  "allServiceEyeDiseasePRKList1",
  "allServiceEyeDiseasePRKList2",
  "allServiceEyeDiseasePRKList3",
  "allServiceEyeDiseasePRKList4",
];

const VSCLIST = [
  "allServiceEyeDiseaseVCSList1",
  "allServiceEyeDiseaseVCSList2",
  "allServiceEyeDiseaseVCSList3",
  "allServiceEyeDiseaseVCSList4",
];

export default function AllService() {
  const { t } = useTranslation();

  return (
    <StyledAllService>
      <PageTop title={t("serviceTitle")} linkList={linkChain} />
      <AllServiceList />
      <AllServiceFaq />
      <AllServiceDisease
        img={PRKIMG}
        title="allServiceEyeDiseasePRKTitle"
        text="allServiceEyeDiseasePRKText"
        list={PRKLIST}
      />
      <AppoinmentSection />
      <AllServiceDisease
        img={VCSIMG}
        title="allServiceEyeDiseaseVCSTitle"
        text="allServiceEyeDiseaseVCSText"
        list={VSCLIST}
        reverse={true}
      />
      <MainReview />
      <AboutClinicForm />
      <Location />
    </StyledAllService>
  );
}

const StyledAllService = styled.main``;
